import { render } from "./OptionalInfoChecklistView.vue?vue&type=template&id=8167b3e8"
import script from "./OptionalInfoChecklistView.vue?vue&type=script&lang=js"
export * from "./OptionalInfoChecklistView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__